import { h, Component } from 'preact';
import Store from 'store/store';

const loadStyle = async url => {
	if (document.querySelector(`link[href="${url}"]`)) return;
	return new Promise((res, rej) => {
		let link = document.createElement('link');
		link.setAttribute('rel', 'stylesheet');
		link.onload = res;
		link.onerror = rej;
		link.href = url;
		document.head.appendChild(link);
	});
};

import s from 'components/bolt/map/map.sss';

export default class Home extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.load();
	}

	componentWillUnmount() {
		this.cleanup?.();
	}

	async load() {
		let root = `${__MEDIA_ROOT__}/lib/gobber`;
		if ((__IS_LOCAL__ || __IS_DEMO__) && new URLSearchParams(location.search).has('local')) {
			root = 'http://localhost:5500/';
		}
		const [{ init }] = await Promise.all([
			import(/* webpackIgnore: true */ `${root}/gobber.js`),
			loadStyle(`${root}/gobber.css`),
		]);
		let imgRoot = this.props.appData.urls.roots.image;
		let audio = this.props.appData.pages.map.data.audio;
		let copy = this.props.appData.pages.map.data.copy;
		let video = this.props.appData.pages.map.data.video;
		let images = this.props.appData.pages.map.data.images;
		this.cleanup = init({
			element: this.base,
			copy: {
				map: {
					tt: {
						src: this.props.appData.pages.map.data.tt
					},
					introCopy: {
						contentTop: {
							heading: copy?.introCopy?.heading || 'Welcome to berk',
							text: copy?.introCopy?.text || 'This is Berk. We have dragons.',
						},
						contentBottom: {
							text: [copy?.introCopy?.exploreButtonTop, copy?.introCopy?.exploreButtonBottom] || ['Explore', 'Berk'],
						}
					},
					markerData: {
						workshop: copy?.map?.workshop|| 'Hiccup\'s Workshop',
						house: copy?.map?.house || 'The Chief\'s House',
						village: copy?.map?.village || 'The Village',
						arena: copy?.map?.arena || 'The Arena',
						greatHall: copy?.map?.greatHall || 'The Great Hall & Library',
					},
					cursor: {
						text: copy?.map?.cursor || 'DRAG'
					},
					nav: {
						topNav: {
							close: copy?.map?.topNav.close || 'CLOSE',
							menu: copy?.map?.topNav.menu || 'MENU',
							returnToMap: copy?.map?.topNav.returnToMap || 'RETURN TO MAP',
						},
						bottomNav: {
							workshop: copy?.map?.bottomNav.workshop|| 'Hiccup\'s Workshop',
							house: copy?.map?.bottomNav.house || 'The Chief\'s House',
							village: copy?.map?.bottomNav.village || 'The Village',
							arena: copy?.map?.bottomNav.arena || 'The Arena',
							greatHall: copy?.map?.bottomNav.greatHall || 'The Great Hall & Library',
							locations: copy?.map?.bottomNav.locations || 'Locations',
						}
					}
				},
				locationEntryContent: {
					workshop: [
						{
							src: audio?.workshop || `${imgRoot}/regions/us/audio/workshop_soundscape.mp3`,
						}
					],
					house: [
						{
							src: audio?.houseOne || `${imgRoot}/regions/us/audio/stoicks_house_soundscape.mp3`,
						},
						{
							src: audio?.houseTwo || `${imgRoot}/regions/us/audio/locations/door_close.mp3`,
						},
					],
					village: [
						{
							src: audio?.village || `${imgRoot}/regions/us/audio/village_soundscape.mp3`,
						}
					],
					arena: [
						{
							src: audio?.arenaOne || `${imgRoot}/regions/us/audio/arena_soundscape.mp3`,
						},
						{
							src: audio?.arenaTwo || `${imgRoot}/regions/us/audio/locations/arena_intro_dialogue.mp3`,
						},
					],
					greatHall: [
						{
							src: audio?.greatHallOne || `${imgRoot}/regions/us/audio/the_great_hall_soundscape.mp3`,
						},
						{
							src: audio?.greatHallTwo || `${imgRoot}/regions/us/audio/locations/door_closing.mp3`,
						},
					]
				},						
				hotspots: {
					workshopTrainingAxe: copy?.hotspots?.workshopTrainingAxe || "Hiccup's Training Axe",
					workshopNoteBook_0: copy?.hotspots?.workshopNoteBook_0 || 'Hiccup',
					workshopFeaturette: copy?.hotspots?.workshopFeaturette || 'Hiccup',
					workshopDragonBio: copy?.hotspots?.workshopDragonBio || 'Toothless',
					stoicksBio: copy?.hotspots?.stoicksBio || 'Stoick The Vast',
					stoicksAxe: copy?.hotspots?.stoicksAxe || "Stoick's Axe",
					stoicksSword: copy?.hotspots?.stoicksSword || "Stoick's Sword",
					stoicksFeaturette: copy?.hotspots?.stoicksFeaturette || 'Father & Son',
					sheetMusic_0: copy?.hotspots?.sheetMusic_0 || 'Sheet Music',
					tapestry_0: copy?.hotspots?.sheetMusic_0 || 'Viking Tapestry 1',
					tapestry_1: copy?.hotspots?.sheetMusic_1 || 'Viking Tapestry 2',
					tapestry_2: copy?.hotspots?.sheetMusic_2 || 'Viking Tapestry 3',
					tapestry_3: copy?.hotspots?.sheetMusic_3 || 'Viking Tapestry 4',
					tapestry_4: copy?.hotspots?.sheetMusic_4 || 'Viking Tapestry 5',
					tapestry_5: copy?.hotspots?.sheetMusic_5 || 'Viking Tapestry 6',
					tapestry_6: copy?.hotspots?.sheetMusic_6 || 'Viking Tapestry 7',
					tapestry_7: copy?.hotspots?.sheetMusic_7 || 'Viking Tapestry 8',
					tapestry_8: copy?.hotspots?.sheetMusic_8 || 'Viking Tapestry 9',
					tapestry_9: copy?.hotspots?.sheetMusic_9 || 'Viking Tapestry 10',
					tapestry_10: copy?.hotspots?.sheetMusic_10 || 'Viking Tapestry 11',
					bookOfDragons: copy?.hotspots?.bookOfDragons || 'Dean Deblois & The Book Of Dragons',
					vikingsInBerk: copy?.hotspots?.vikingsInBerk || 'The Vikings In Berk',
					fishlegCards: copy?.hotspots?.fishlegCards || "FishLeg's Card Collection",
					villageFeaturette: copy?.hotspots?.villageFeaturette || 'John Powell & The Film Score',
					villageSoundtrack: copy?.hotspots?.villageSoundtrack || "Listen to 'Test Drive' by John Powell",
					villageSheetMusic_0: copy?.hotspots?.villageSheetMusic_0 || 'Sheet Music',
					arenaGateA: copy?.hotspots?.arenaGateA || 'The Deadly Nadder',
					arenaGateB: copy?.hotspots?.arenaGateB || 'The Hideous Zippleback',
					arenaGateC: copy?.hotspots?.arenaGateC || 'The Terrible Terror',
					arenaGateD: copy?.hotspots?.arenaGateD || 'The Gronkle',
					arenaGateE: copy?.hotspots?.arenaGateE || 'The Montstrous Nightmare',
					arenaRecruitBios: copy?.hotspots?.arenaRecruitBios || 'The Recruits',
					arenaFeaturette: copy?.hotspots?.arenaFeaturette || 'Welcome to the Arena',
					arenaGobber: copy?.hotspots?.arenaGobber || 'Gobber'
				},
				content: {
					instructions: [{
						content: [copy?.instructions.explore, copy?.instructions.exploreSets, copy?.instructions.dragToRotate, copy?.instructions.inspect, copy?.instructions.move, copy?.instructions.exploreLocation || ['Explore', 'Explore sets from the movie and find exclusive content', 'Drag to rotate', 'Inspect', 'Move', 'Explore Location']],
					}],
					workshopDragonBio: [
						{
							type: 'audio',
							src: audio?.workshopDragonBio || `${imgRoot}/regions/us/audio/hotspots/workshop_dragon_details.mp3`
						},
						{
							type: 'video',
							src: video?.workshopDragonBio || `${imgRoot}/regions/us/video/hotspots/Toothless.mp4`
						},
						{
							type: 'h1',
							content: copy?.hiccupsWorkshop?.h1 || 'Toothless'
						},
						{
							type: 'p',
							content: copy?.hiccupsWorkshop?.paragraph1
						},
						{
							type: 'p',
							content: copy?.hiccupsWorkshop?.paragraph2
						}
					],
					workshopTrainingAxe: [
						{
							src: audio?.workshopTrainingAxeOne || `${imgRoot}/regions/us/audio/hotspots/dialogue_when_you_carry_this_axe.mp3`
						},
						{
							src: audio?.workshopTrainingAxeTwo || `${imgRoot}/regions/us/audio/hotspots/drawing_axe.mp3`
						},
					],
					workshopFeaturette: [
						{
							type: 'video',
							src: video?.workshopFeaturette || `${imgRoot}/regions/us/video/hotspots/HiccupBioVideo.mp4`
						},
						{
							type: 'h1',
							content: copy?.hiccupsWorkshop?.workshopFeaturette?.h1 || 'HICCUP HORRENDOUS HADDOCK III'
						},
						{
							type: 'p',
							content: copy?.hiccupsWorkshop?.workshopFeaturette?.paragraph1
						},
						{
							type: 'p',
							content: copy?.hiccupsWorkshop?.workshopFeaturette?.paragraph2
						},
						{
							type: 'p',
							content: copy?.hiccupsWorkshop?.workshopFeaturette?.paragraph3
						}
					],
					stoicksBio: [
						{
							type: 'img',
						},
						{
							type: 'h1',
							content: copy?.stoicksHouse?.h1 || 'Stoick the Vast'
						},
						{
							type: 'p',
							content: copy?.stoicksHouse?.paragraph1
						},
						{
							type: 'p',
							content: copy?.stoicksHouse?.paragraph2
						},
						{
							type: 'p',
							content: copy?.stoicksHouse?.paragraph3
						}
					],
					stoicksAxe: [
						{
							src: audio?.stoicksAxe || `${imgRoot}/regions/us/audio/hotspots/stoicks_axe_audio?.mp3`
						},
					],
					stoicksSword: [
						{
							src: audio?.stoicksSword || `${imgRoot}/regions/us/audio/hotspots/draw_sword.mp3`
						},
					],
					stoicksFeaturette: [	
						{ src: video?.stoicksFeaturette || `${imgRoot}/regions/us/video/featurette/chief-house_father-and-son/Chiefs_House_featurette_optimised.mp4` },
					],
					arenaGateA: [
						{
							type: 'audio',
							src: audio?.arenaGateA || `${imgRoot}/regions/us/audio/hotspots/arena_gate_A_deadly_nadder.mp3`
						},
						{
							type: 'video',
							src: video?.arenaGateA || `${imgRoot}/regions/us/video/hotspots/Nadder.mp4`
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaGateA?.h1 || 'The Deadly Nadder'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGateA?.paragraph1
						},
					],
					arenaGateB: [
						{
							type: 'audio',
							src: audio?.arenaGateB || `${imgRoot}/regions/us/audio/hotspots/arena_gate_B_hideous_zippleback.mp3`
						},
						{
							type: 'video',
							src: video?.arenaGateB || `${imgRoot}/regions/us/video/hotspots/Zippleback.mp4`
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaGateB?.h1 || 'The Hideous Zippleback'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGateB?.paragraph1
						}
					],
					arenaGateC: [
						{
							type: 'audio',
							src: audio?.arenaGateC || `${imgRoot}/regions/us/audio/hotspots/arena_gate_C_the_terrible_terror.mp3`
						},
						{
							type: 'video',
							src: video?.arenaGateC || `${imgRoot}/regions/us/video/hotspots/TerribleTerror.mp4`
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaGateC?.h1 || 'The Terrible Terror'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGateC?.paragraph1
						}
					],
					arenaGateD: [
						{
							type: 'audio',
							src: audio?.arenaGateD || `${imgRoot}/regions/us/audio/hotspots/arena_gate_D_gruesome_gronkle.mp3`
							
						},
						{
							type: 'video',
							src: video?.arenaGateD || `${imgRoot}/regions/us/video/hotspots/GronkleToolkit.mp4`
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaGateD?.h1 || 'The Gronkle'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGateD?.paragraph1
						}
					],
					arenaGateE: [
						{
							type: 'audio',
							src: audio?.arenaGateE || `${imgRoot}/regions/us/audio/hotspots/arena_gate_E_monstrous_nightmare.mp3`
						},
						{
							type: 'video',
							src: video?.arenaGateE || `${imgRoot}/regions/us/video/hotspots/MonstrousNightmare.mp4`
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaGateE?.h1 || 'The Montstrous Nightmare'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGateE?.paragraph1
						}
					],
					arenaRecruitBios: [
						{
							type: 'h1',
							content: copy?.arena?.arenaRecruitBios?.h1 || 'The Recruits'
						},
						{
							type: 'img',
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaRecruitBios?.astrid?.h1 || 'Astrid'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.astrid?.paragraph1
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.astrid?.paragraph2
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.astrid?.paragraph3
						},
						{
							type: 'img',
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaRecruitBios?.snotlout?.h1 || 'Snotlout'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.snotlout?.paragraph1
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.snotlout?.paragraph2
						},
						{
							type: 'img',
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaRecruitBios?.fishlegs?.h1 || 'Fishlegs'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.fishlegs?.paragraph1
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.fishlegs?.paragraph2
						},
			
			
						{
							type: 'img',
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaRecruitBios?.ruffnutAndTuffnut?.h1 || 'Ruffnut & Tuffnut'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.ruffnutAndTuffnut?.paragraph1
						},
						{
							type: 'p',
							content: copy?.arena?.arenaRecruitBios?.ruffnutAndTuffnut?.paragraph2
						},
					],
					arenaFeaturette: [
						{
							src: video?.arenaFeaturette || `${imgRoot}/regions/us/video/featurette/arena_welcome-to-the-arena/The_Arena_featurette_optimised.mp4`,
						},
					],
					arenaGobber: [
						{
							type: 'img',
						},
						{
							type: 'h1',
							content: copy?.arena?.arenaGobber?.h1 || 'Gobber'
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGobber?.paragraph1
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGobber?.paragraph2
						},
						{
							type: 'p',
							content: copy?.arena?.arenaGobber?.paragraph3
						},
					],
					villageSheetMusic: [
						{
							type: 'carousel',
							slides: [
								images?.sheetMusicA || `${imgRoot}/regions/us/sheet-music/sheet-music-1.svg`,
								images?.sheetMusicB || `${imgRoot}/regions/us/sheet-music/sheet-music-2.svg`,
								images?.sheetMusicC || `${imgRoot}/regions/us/sheet-music/sheet-music-3.svg`,
								images?.sheetMusicD || `${imgRoot}/regions/us/sheet-music/sheet-music-4.svg`,
								images?.sheetMusicE || `${imgRoot}/regions/us/sheet-music/sheet-music-5.svg`,
								images?.sheetMusicF || `${imgRoot}/regions/us/sheet-music/sheet-music-6.svg`,
								images?.sheetMusicG || `${imgRoot}/regions/us/sheet-music/sheet-music-7.svg`,
								images?.sheetMusicH || `${imgRoot}/regions/us/sheet-music/sheet-music-8.svg`,
								images?.sheetMusicI || `${imgRoot}/regions/us/sheet-music/sheet-music-9.svg`,
								images?.sheetMusicJ || `${imgRoot}/regions/us/sheet-music/sheet-music-10.svg`,
								images?.sheetMusicK || `${imgRoot}/regions/us/sheet-music/sheet-music-11.svg`,
								images?.sheetMusicL || `${imgRoot}/regions/us/sheet-music/sheet-music-12.svg`,
								images?.sheetMusicM || `${imgRoot}/regions/us/sheet-music/sheet-music-13.svg`,
								images?.sheetMusicN || `${imgRoot}/regions/us/sheet-music/sheet-music-14.svg`,
								images?.sheetMusicO || `${imgRoot}/regions/us/sheet-music/sheet-music-15.svg`,
								images?.sheetMusicP || `${imgRoot}/regions/us/sheet-music/sheet-music-16.svg`,
								images?.sheetMusicQ || `${imgRoot}/regions/us/sheet-music/sheet-music-17.svg`,
								images?.sheetMusicR || `${imgRoot}/regions/us/sheet-music/sheet-music-18.svg`,
								images?.sheetMusicS || `${imgRoot}/regions/us/sheet-music/sheet-music-19.svg`,
								images?.sheetMusicT || `${imgRoot}/regions/us/sheet-music/sheet-music-20.svg`,
								images?.sheetMusicU || `${imgRoot}/regions/us/sheet-music/sheet-music-21.svg`,
								images?.sheetMusicV || `${imgRoot}/regions/us/sheet-music/sheet-music-22.svg`,	
							]
						}
					],	
					bookOfDragons: [
						{
							src: video?.bookOfDragonsFeaturette || `${imgRoot}/regions/us/video/featurette/great-hall_book-of-dragons/book_of_dragons_featurette_optimised.mp4`
						},
					],
					vikingsInBerk: [
						{
							src: video?.vikingsInBerkFeaturette || `${imgRoot}/regions/us/video/featurette/great-hall_vikings/great_hall_featurette_optimised.mp4`
						},
					],
					villageSoundtrack: [
						{
							type: 'audioPlayer',
							src: audio?.villageSoundtrack || `${imgRoot}/regions/us/audio/villageSoundtrack.mp3`,
							caption: copy?.village?.soundtrack?.caption || 'How To Train Your Dragon Original Soundtrack',
							cta: {
								text: copy?.village?.soundtrack?.ctaText || 'Pre-Order Soundtrack',
								url: copy?.village?.soundtrack?.ctaUrl || 'https://backlotmusic.ffm.to/testdrivetoothless',
							}
						}
					],
					villageFeaturette: [
						{
							type: 'videoPlayer',
							src: video?.villageFeaturette || `${imgRoot}/regions/us/video/featurette/village_john-powell/the_village_featurette_heavy.mp4`
						},
					]
				}
			},
			onMenuClick: () => {
				Store.emit('TRIGGER_BURGER_BTN');
			},
		});
		window.__manualMapCleanup = this.cleanup;
		window.__manualMapReload = () => this.load();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return false;
	}

	render() {
		return <div class={s.container} />;
	}
}